import ClearTextField from 'components/TextFields/ClearTextField';
import SearchClearButton from 'components/SearchClearButton';
import SearchBox from 'components/SearchBox';
import { Checkbox } from '@entur/form';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { TransactionTypesSearchParamsType } from '../api/getTransactionTypes';

interface TransactionTypesSearchBoxProps {
  defaultSearchParams: TransactionTypesSearchParamsType;
  searchParams: TransactionTypesSearchParamsType;
  handleSearch: (data: TransactionTypesSearchParamsType) => void;
}

export const TransactionTypesSearchBox = ({
  defaultSearchParams,
  searchParams,
  handleSearch,
}: TransactionTypesSearchBoxProps) => {
  const intl = useIntl();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<TransactionTypesSearchParamsType>({
    mode: 'onBlur',
    defaultValues: { name: searchParams.name, type: searchParams.type, discontinued: searchParams.discontinued },
  });

  const clearForm = () => {
    reset({
      name: defaultSearchParams.name,
      type: defaultSearchParams.type,
      discontinued: defaultSearchParams.discontinued,
    });
  };

  const searchForm = handleSubmit((data) => {
    handleSearch(data);
  });

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchForm();
    }
  };

  return (
    <SearchBox>
      <ClearTextField
        {...register('name', {
          maxLength: { value: 80, message: intl.formatMessage({ id: 'warnings.maxLength' }, { number: 80 }) },
        })}
        onKeyDown={handleKeyPress}
        label={intl.formatMessage({ id: 'generalValues.name' })}
        feedback={errors.name?.message as string}
        variant={errors.name ? 'error' : 'info'}
        autoFocus
        autoComplete="off"
      />
      <ClearTextField
        {...register('type', {
          maxLength: { value: 30, message: intl.formatMessage({ id: 'warnings.maxLength' }, { number: 30 }) },
        })}
        label={intl.formatMessage({ id: 'generalValues.type' })}
        onKeyDown={handleKeyPress}
        feedback={errors.type?.message as string}
        variant={errors.type ? 'error' : 'info'}
        autoComplete="off"
      />
      <SearchBox.Actions>
        <Checkbox {...register('discontinued')}>
          {intl.formatMessage({ id: 'transactionTypes.showDiscontinued' })}
        </Checkbox>
        <SearchClearButton clearForm={clearForm} searchForm={searchForm} />
      </SearchBox.Actions>
    </SearchBox>
  );
};
